import type { Nil, Unit, UserPreferredUnit } from '@core';

import { ParameterCard } from '../ParameterCard';
import type { CorridorBounds } from '../types';
import { useParameters } from '../useParameters';

export type LiveAnalysisParameterCardProps = {
    title: string;
    unit: Unit;
    userPreferredUnit: UserPreferredUnit;
    value: number | Nil;
    goalCorridor?: CorridorBounds | Nil;
};

export const LiveAnalysisParameterCard = ({
    title,
    unit,
    userPreferredUnit,
    value,
    goalCorridor,
}: LiveAnalysisParameterCardProps) => {
    const converted = useParameters({
        unit,
        value,
        comparisonValue: undefined,
        userPreferredUnit,
        goalCorridorParameterMargins: goalCorridor,
        mean: undefined,
        stdDev: undefined,
    });

    return (
        <ParameterCard.Root
            corridors={
                <ParameterCard.SingleCorridor
                    goalCorridor={converted.goalCorridor}
                    unit={converted.unit}
                    value={converted.value}
                    indicatorColor={converted.goalIndicatorColor}
                />
            }
        >
            <ParameterCard.Title>{title}</ParameterCard.Title>
            <ParameterCard.Values>
                <ParameterCard.Value
                    displayUnit={converted.unit}
                    value={converted.value}
                    symbol={converted.symbol}
                    fixedWidth
                    indicatorColor={converted.goalIndicatorColor}
                />
            </ParameterCard.Values>
        </ParameterCard.Root>
    );
};
